module.exports = __webpack_public_path__ + "img/home_logo1.3d4260c1.png";